<template>
    <div v-loading="loading">
        <div class="row mb-2" v-if="validationErrors">
            <div class="col">
                <el-alert type="error" >
                {{ validationErrors }}
                </el-alert>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-6">
                <base-input
                type="text"
                label="Name"
                placeholder="Name"
                v-model="form.name"
                >
                </base-input>
            </div>
            <div class="col-lg-6">
                <base-input
                label="Event Type"
                >
                  <el-select v-model="form.event_type" placeholder="Event Type">
                      <el-option value="">
                      </el-option>
                      <el-option
                      v-for="(label, key) in eventTypes"
                      :key="key"
                      :label="label"
                      :value="key">
                      </el-option>
                  </el-select>
                </base-input>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-6">
                <div class="form-group">
                    <label class="form-control-label">Event Date</label>
                    <el-date-picker
                        v-model="form.event_date"
                        type="date"
                        placeholder="Select date"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        style="width: 100%"
                    ></el-date-picker>
                </div>
            </div>
             <div class="col-lg-6">
                <base-input
                  label="Location"
                >
                  <el-select v-model="form.location_id" placeholder="Location">
                      <el-option
                        v-for="item in locationOptions"
                        :key="'location_' + item.id"
                        :label="item.name"
                        :value="item.id">
                      </el-option>
                  </el-select>
                </base-input>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-6">
                <base-input
                type="text"
                label="Estimated Guests"
                placeholder="Estimated Guests"
                v-model="form.estimated_guests"
                >
                </base-input>
            </div>
            <div class="col-lg-6">
                <base-input
                type="text"
                label="Estimated Budget"
                placeholder="Estimated Budget"
                v-model="form.estimated_budget"
                >
                </base-input>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-12">
                <el-alert
                v-if="!leadEvent.is_pipeline_attached"
                title="Alert"
                type="info"
                description="This event is not currently synchronized with HubSpot. Clicking on the 'Save' button will update this event as a deal in HubSpot. You can change the deal stage using the 'Pipeline' button on the event list."
                show-icon>
                </el-alert>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-12 text-right">
                <a class="btn btn-primary" @click="saveLeadEvent">Save</a>
            </div>
        </div>
    </div>
</template>
<script>
import {
  Select,
  Option,
  Alert,
  DatePicker,
  Notification,
} from "element-ui";
import { mapState } from "vuex";
import datePicker from "vue-bootstrap-datetimepicker";
import {eventTypes} from '@/../app.config';
import LeadEventService from '@/services/lead-event.service';
import leadEventService from "@/services/lead-event.service";
import moment from 'moment';

export default {
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Alert.name]: Alert,
    [DatePicker.name]: DatePicker,
    [Notification.name]: Notification,
    datePicker,
  },
  props: {
    leadEvent:  {
      type: Object,
      required: true,
    },
    event_type: {
      type: String,
      required: false,
      default: ''
    }
  },
  data() {
    return {
      form: {
        location_id: this.leadEvent.location_id || null,
        name: this.leadEvent.name,
        event_type: this.event_type || this.leadEvent.event_type,
        event_date: this.extractDateFromDateTime(this.leadEvent.event_start),
        event_start: this.leadEvent.event_start,
        event_end: this.leadEvent.event_end,
        estimated_guests: this.leadEvent.estimated_guests,
        estimated_budget: this.leadEvent.estimated_budget,
      },
      loading: false,
      validationErrors: '',
      locationOptions: [],
      pipelineEventTypeMismatch: false
    };
  },
  created() {
    this.getLocationOptions();
  },
  computed: {
    ...mapState("country/", {
      country: (state) => state.country || 'AU',
    }),
    eventTypes: () => eventTypes,
    selectedDealPipeline() {
        if (!this.form.event_type || !this.pipelineOptions) return null;
        // logic to match event_type to pipeline, simplified here as per previous logic assumptions or mixin availability
        // If complex pipeline logic is needed, we would import the mixin.
        // For 'SimpleBasic', we assume standard behavior or that the mixin is not strictly required if only updating basic properties.
        return null; 
    }
  },
  methods: {
    extractDateFromDateTime(dateTime) {
      if (!dateTime) return '';
      return moment.utc(dateTime).local().format('YYYY-MM-DD');
    },
    async saveLeadEvent() {
      // Update event_start and event_end based on date
      // For simple events, we might assume full day or keep time if present, 
      // but requirements asked for "event name, event type, event date... send request to old api"
      if (this.form.event_date) {
         // Simple logic: preserve original time or set to start of day?
         // Original Basic.vue used combineDateAndTime. Let's do simple preservation or default.
         // Since user said "old method", we'll just set event_start/end to the date + default time (or current time of leadEvent if exists)
         // For simplicity and safety with "old API", we construct a basic datetime.
         this.form.event_start = moment(this.form.event_date).format('YYYY-MM-DD 09:00:00'); // Default start
         this.form.event_end = moment(this.form.event_date).format('YYYY-MM-DD 17:00:00');   // Default end
      }

      this.loading = true;
      this.validationErrors = '';
      let self = this;

      LeadEventService.updateLeadEventData(this.leadEvent.id, this.form)
        .then(async () => {
          await self.$store.dispatch("leads/getLeadEvents", self.leadEvent.lead_id);
          
          Notification.success({
            title: 'Success',
            message: 'Event saved successfully!',
            type: 'success',
          });

          self.$emit('onSave');
          self.loading = false;
        })
        .catch((error) => {
          self.validationErrors = error.response ? error.response.data.error.message : error.message;
          self.loading = false;
        });
    },
    getLocationOptions() {
      leadEventService.getEventLocations(this.country)
        .then(response => {
          this.locationOptions = response.data.eventLocations;
          if (this.form.location_id) {
             const locationId = this.form.location_id;
             this.form.location_id = null;
             this.$nextTick(() => { this.form.location_id = locationId; });
          }
        })
        .catch(error => {
          console.error("Error fetching event locations:", error);
        });
    }
  },
  watch: {
    leadEvent: {
        handler(val) {
            if(val) {
                 this.form.name = val.name;
                 this.form.event_type = val.event_type;
                 this.form.event_date = this.extractDateFromDateTime(val.event_start);
                 this.form.location_id = val.location_id;
                 this.form.estimated_guests = val.estimated_guests;
                 this.form.estimated_budget = val.estimated_budget;
            }
        },
        deep: true
    },
    'form.event_type': function(newType, oldType) {
        if (newType !== oldType) {
            this.$emit('eventTypeChange', newType);
        }
    }
  }
}
</script>
